(() => {
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'fr-CA', { style:'currency', currency:window.Shopify?.currency?.active || 'CAD' }).format(cents / 100);
  const normalize = (value) => String(value || '').trim().toLowerCase();

  document.querySelectorAll('[data-vs-page]').forEach((page) => {
    const variantsNode = page.querySelector('[data-vs-variants]');
    const form = page.querySelector('[data-vs-form]');
    if (!variantsNode || !form) return;
    let variants;
    try { variants = JSON.parse(variantsNode.textContent); } catch (error) { console.error(error); return; }

    const groups = [...page.querySelectorAll('[data-vs-option]')];
    const idInput = page.querySelector('[data-vs-variant-id]');
    const quantity = page.querySelector('[data-vs-quantity]');
    const quantityHidden = page.querySelector('[data-vs-quantity-hidden]');
    const price = page.querySelector('[data-vs-price]');
    const compare = page.querySelector('[data-vs-compare]');
    const submit = page.querySelector('[data-vs-submit]');
    const message = page.querySelector('[data-vs-message]');
    const shirt = page.querySelector('[data-vs-shirt-base]');
    const design = page.querySelector('[data-vs-shirt-design]');
    const preview = page.querySelector('[data-vs-preview]');
    const orderApi = page.dataset.vsOrderApi;
    const modelName = page.dataset.vsModel || document.querySelector('h1')?.textContent?.trim() || 'Victoria Carter';

    const selections = () => groups.map((group) => group.querySelector('.is-active')?.dataset.vsValue || '');
    const currentVariant = () => variants.find((variant) => variant.options.every((value,index) => value === selections()[index]));
    const updateVisual = (button) => {
      if (!button) return;
      if (button.dataset.shirtSrc && shirt) shirt.src = button.dataset.shirtSrc;
      if (button.dataset.designSrc && design) design.src = button.dataset.designSrc;
      if (button.dataset.shirtSrc && preview) {
        preview.textContent = `Aperçu indicatif · ${button.dataset.vsValue} · Devant`;
      }
    };

    const refresh = () => {
      const variant = currentVariant();
      const qty = Math.max(1, Number(quantity.value) || 1);
      quantity.value = qty;
      quantityHidden.value = qty;
      if (variant) {
        idInput.value = variant.id;
        price.textContent = money(variant.price);
        compare.hidden = !(variant.compare_at_price > variant.price);
        if (!compare.hidden) compare.textContent = money(variant.compare_at_price);
      }
      const available = Boolean(variant?.available);
      submit.disabled = !available;
      submit.textContent = available ? `Ajouter au panier · ${qty} × ${money(variant.price)} 🛒` : 'Combinaison non disponible';
      const selected = selections();
      groups.forEach((group,index) => group.querySelectorAll('[data-vs-value]').forEach((button) => {
        const candidate = [...selected]; candidate[index] = button.dataset.vsValue;
        button.disabled = !variants.some((item) => item.available && candidate.every((value,i) => !value || item.options[i] === value));
      }));
    };

    groups.forEach((group) => group.addEventListener('click', (event) => {
      const button = event.target.closest('[data-vs-value]');
      if (!button || button.disabled) return;
      group.querySelectorAll('[data-vs-value]').forEach((item) => {
        const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', String(active));
      });
      group.querySelector('[data-vs-selected]')?.replaceChildren(button.dataset.vsValue);
      updateVisual(button);
      refresh();
    }));

    page.querySelector('[data-vs-minus]').addEventListener('click', () => { quantity.value = Math.max(1,(Number(quantity.value)||1)-1); refresh(); });
    page.querySelector('[data-vs-plus]').addEventListener('click', () => { quantity.value = (Number(quantity.value)||1)+1; refresh(); });
    quantity.addEventListener('change', refresh);

    const sendSelection = async (variant, qty) => {
      if (!orderApi) throw new Error("L'adresse d'envoi du choix est absente.");
      const chosen = groups.map((group, index) => ({
        name: group.dataset.vsOptionName || `Option ${index + 1}`,
        value: selections()[index] || ''
      }));
      const options = Object.fromEntries(chosen.map((option) => [option.name, option.value]));
      const response = await fetch(orderApi, {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body:JSON.stringify({
          event:'shopify_add_to_cart',
          product:modelName,
          variantId:String(variant.id),
          quantity:qty,
          price:variant.price,
          currency:window.Shopify?.currency?.active || 'CAD',
          options,
          productUrl:window.location.href,
          shop:window.location.hostname,
          occurredAt:new Date().toISOString()
        })
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.ok) throw new Error(result.error || "L'avis d'ajout au panier n'a pas pu être envoyé.");
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const variant = currentVariant();
      if (!variant?.available) return;
      const qty = Math.max(1,Number(quantity.value)||1);
      submit.disabled = true; submit.textContent = 'Envoi du choix…'; message.textContent = '';
      try {
        await sendSelection(variant, qty);
        submit.textContent = 'Ajout au panier…';
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ items:[{ id:variant.id, quantity:qty }] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Ajout impossible');
        window.location.assign(window.routes?.cart_url || '/cart');
      } catch (error) {
        message.textContent = error.message; submit.disabled = false; refresh();
      }
    });
    updateVisual(page.querySelector('[data-vs-option] .is-active[data-shirt-src]'));
    refresh();
  });
})();
